<template>
  <el-row
    style="
      border: 1px silver solid;
      border: 1px solid #ccc;
      padding: 20px 0;
      border-radius: 4px;
      margin-top: 15px;
    "
  >
    <el-col
      :span="colSpan"
      v-for="(item, index) in dataList"
      :key="item.value"
      class="col"
    >
      <a class="quick-entry" :href="item.href" target="_blank">
        <span class="content" :class="{ extentContent: item.extendIcon }">
          <span
            ><svg-icon class="svg" :icon-class="item.icon_class"></svg-icon>
            <span>{{ item.label }}</span></span
          >
        </span>
        <el-divider
          direction="vertical"
          v-if="index != dataList.length - 1"
        ></el-divider>
      </a>
      <!-- <div class="quick-entry"> -->

      <!-- </div> -->
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "QuickEntrySvg",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    colSpan() {
      return 24 / this.dataList.length;
    },
  },
  methods: {
    // rouJump(path) {
    //   let routerJump = this.$router.resolve({ path: path });
    //   window.open(routerJump.href, "_blank");
    // },
  },
};
</script>

<style scoped lang="less">
@import "../../styles/theme";
.col {
  text-align: right;
  // width: 25%;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
}
.col {
  text-align: right;
  border-right: 1px solid #2c3e50;
}
.col:last-child {
  // border: 1px silver solid;
  border-right: none !important;
}

.quick-entry {
  padding: 22px 0;
  font-size: 18px;
  color: #303133;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .content {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    // margin-right: 30%;
    span {
      display: flex;
      justify-content: space-around;
      vertical-align: top;
      align-items: center;
      margin-right: 3rem;
      .svg {
        margin-left: 5rem;
      }
      span {
        width: 6rem;
        margin-left: 2rem;
      }
    }
  }
  .content:hover {
    color: @theme-color;
  }
  .extendIcon {
    color: #2264a0;
    margin-right: 5px;
    cursor: pointer;
  }
  .extentContent {
    margin-right: 20%;
  }
  .el-divider--vertical {
    background-color: #2c3e50;
    height: 4rem;
  }
}
</style>
